import { MoveRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CAPITAL_STACK } from "@/data/content";

const SLUGS = [
  "bank-debt",
  "nbfc",
  "private-credit",
  "structured-credit",
  "special-situations",
  "equity-capital",
];

const CapitalStack = () => (
  <section
    id="capital-solutions"
    data-testid="capital-solutions-section"
    className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32"
  >
    <SectionHeading
      number="03"
      label="Capital Solutions"
      title="The capital spectrum"
    />
    <Reveal delay={0.1}>
      <p className="mt-8 max-w-2xl text-base font-light leading-relaxed text-slate-400 sm:text-lg">
        The objective is not simply to find a lender — it is to identify the
        appropriate form of capital for the requirement, then structure and
        place it accordingly.
      </p>
    </Reveal>

    <Reveal delay={0.15}>
      <div
        data-testid="capital-stack-visual"
        className="mt-16 flex snap-x snap-mandatory items-stretch gap-3 overflow-x-auto pb-4 lg:grid lg:grid-cols-6 lg:gap-0 lg:overflow-visible lg:border lg:border-white/10 lg:pb-0"
      >
        {CAPITAL_STACK.map((tier, i) => (
          <div
            key={tier.name}
            data-testid={`capital-tier-${SLUGS[i]}`}
            className="group relative flex w-56 shrink-0 snap-start flex-col border border-white/10 bg-[#0D1220] p-6 transition-all duration-500 hover:-translate-y-1 hover:border-[#F26122]/40 hover:bg-[#111827] hover:shadow-[0_28px_56px_-28px_rgba(16,23,37,0.22)] lg:w-auto lg:shrink lg:border-0 lg:border-r lg:border-white/10 lg:last:border-r-0"
          >
            <span className="font-mono2 text-[10px] tracking-[0.25em] text-slate-600 transition-colors duration-300 group-hover:text-[#F2824F]">
              0{i + 1}
            </span>
            <div
              className="mt-8 w-full bg-[#0D1220]/10 transition-colors duration-500 group-hover:bg-[#F26122]/15"
              style={{ height: `${28 + i * 14}px` }}
              aria-hidden="true"
            />
            <h3 className="mt-5 font-display text-lg font-normal leading-tight text-slate-100 transition-colors duration-300 group-hover:text-[#F26122]">
              {tier.name}
            </h3>
            <p className="mt-3 text-xs font-light leading-relaxed text-slate-500 transition-colors duration-300 group-hover:text-slate-400">
              {tier.description}
            </p>
            {i < CAPITAL_STACK.length - 1 && (
              <MoveRight
                className="absolute -right-2.5 top-1/2 z-10 hidden h-4 w-4 -translate-y-1/2 text-[#F2824F]/60 lg:block"
                aria-hidden="true"
              />
            )}
          </div>
        ))}
      </div>
    </Reveal>

    <Reveal delay={0.2}>
      <div className="mt-6 flex items-center justify-between font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-600">
        <span>Senior · Secured · Conventional</span>
        <span className="hidden sm:inline">Flexible · Structured · Patient</span>
      </div>
    </Reveal>
  </section>
);

export default CapitalStack;
